import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Row, Col } from '@design-system-etat/dsfr-react';
import { getPath } from '../../../../../../../../utils/router';
import {
    API_MODIFIER_REPRISE_DE_DONNEES_ARME,
    CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME,
} from '../../../../../../../../constants/apiUrls.constants';
import RoutesRatelier from '../../../../../routes';
import usagerClientReducer from '../../../../../../../../store/usagerReducer';
import BoutonEtape from '../../../../../../../../components/form/boutonsEtape/BoutonEtape';

const ArmeCorrigerInformationsEtape2 = ({
    etapePrecedente,
    tableauConfig,
    armeModifier,
    dataGdr,
    armeCorrigerInformations,
    postApi,
    reinitialiseApi,
    erreurArme,
}) => {
    const { handleSubmit } = useForm({
        mode: 'onChange',
    });
    const history = useHistory();

    const [loadingArmeModifieePreview, setLoadingArmeModifieePreview] = useState(false);
    const [armeModifieePreview, setArmeModifieePreview] = useState([]);

    useEffect(() => {
        if (armeModifier !== null && Array.isArray(Object.values(armeModifier))) {
            setLoadingArmeModifieePreview(true);
            let liste = [];
            let listeRga = [];

            if (armeCorrigerInformations.nouveauNumeroRga) {
                listeRga = [
                    armeCorrigerInformations.nouveauNumeroRga,
                    armeCorrigerInformations.nouveauNumeroSerie ?? armeModifier.numeroSerie,
                    dataGdr.type,
                    dataGdr.marque,
                    dataGdr.modele,
                    dataGdr.canonUn ? dataGdr.canonUn.libelleCalibre : null,
                    armeModifier.regimeDetention,
                    armeModifier.dateAcquisition,
                ];
            } else {
                listeRga = [
                    armeModifier.numeroRga,
                    armeCorrigerInformations.nouveauNumeroSerie ?? armeModifier.numeroSerie,
                    armeModifier.type,
                    armeModifier.marque,
                    armeModifier.modele,
                    armeModifier.canonUn,
                    armeModifier.regimeDetention,
                    armeModifier.dateAcquisition,
                ];
            }
            liste = liste.concat(listeRga);
            setArmeModifieePreview(liste);
            setLoadingArmeModifieePreview(false);

            if (erreurArme === false) {
                reinitialiseApi(CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME);
                history.push(getPath(RoutesRatelier));
            }
        }
    }, [erreurArme]);

    const onSubmit = () => {
        postApi(
            usagerClientReducer,
            API_MODIFIER_REPRISE_DE_DONNEES_ARME,
            armeCorrigerInformations,
            CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME,
        );
    };

    return (
        <Row>
            <Col col={12}>
                <h2>Nouvelles informations de l&apos;arme</h2>
            </Col>
            <Col col={12}>
                <SimpleTable
                    entete={tableauConfig}
                    donnees={[armeModifieePreview]}
                    isLoading={loadingArmeModifieePreview}
                />
            </Col>
            <Col col={12}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <BoutonEtape
                        nameBtnSuivant="valider"
                        labelBtnSuivant="Valider"
                        labelBtnPrecedent="Revenir à l'étape précédente"
                        actionPrecedente={etapePrecedente}
                        btnSuivantDisabled={false}
                    />
                </form>
            </Col>
        </Row>
    );
};

ArmeCorrigerInformationsEtape2.propTypes = {
    etapePrecedente: PropTypes.func.isRequired,
    tableauConfig: PropTypes.array.isRequired,
    armeModifier: PropTypes.shape({
        numeroRga: PropTypes.string.isRequired,
        numeroSerie: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        marque: PropTypes.string.isRequired,
        modele: PropTypes.string.isRequired,
        canonUn: PropTypes.string,
        regimeDetention: PropTypes.string.isRequired,
        dateAcquisition: PropTypes.string.isRequired,
    }).isRequired,
    dataGdr: PropTypes.shape({
        type: PropTypes.string.isRequired,
        marque: PropTypes.string.isRequired,
        modele: PropTypes.string.isRequired,
        canonUn: PropTypes.shape({
            libelleCalibre: PropTypes.string.isRequired,
        }),
        regimeDetention: PropTypes.string.isRequired,
    }),
    armeCorrigerInformations: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        nouveauNumeroRga: PropTypes.string,
        nouveauNumeroSerie: PropTypes.string,
    }).isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    erreurArme: PropTypes.bool,
};

ArmeCorrigerInformationsEtape2.defaultProps = {
    erreurArme: false,
};

export default connect(
    (state) => {
        const { data: armeModifier } = state.repriseDeDonnees.recupererArme;
        const { data: dataGdr } = state.armes.recupererGdrParNumeroRga;
        const {
            isLoading: isLoadingArmeEnregistree,
            data: armeEnregistree,
            erreur: erreurArme,
        } = state.repriseDeDonnees.modifierArme;
        return {
            armeModifier,
            dataGdr,
            isLoadingArmeEnregistree,
            armeEnregistree,
            erreurArme,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ArmeCorrigerInformationsEtape2);
